// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"b98a3a33","433":"ec8f69d0","540":"a913ecc3","737":"13d09bbb","789":"f4b793af","826":"c36aaaca"}[chunkId] + ".chunk.js";
};